import { useAct } from 'FlowBuilder/store'
import SelectField from "Shared/components/SelectField";
import ActionTranslationSettings, { ContentVariantTranslationSettings, TranslateOptions } from "./TranslationSettings/ActionTranslationSettings";
import FlowTranslationSettings from "./TranslationSettings/FlowTranslationSettings";
import './TranslationSettings/TranslationSettings.scoped.scss'
import orderActions from 'FlowTaker/lib/orderActions'
import { clientLanguagesData } from 'Shared/TranslatableTextContent/clientLanguagesData';

export default function TranslationSettingsForm() {
  const act = useAct();
  const flow = useSel(s => s.builder.flow)
  const actions = useSel(s => _.values(s.actions.entities) || [])
  const orderedActions = orderActions(actions)
  const clientLanguages = useMemo(() => clientLanguagesData());

  const [collapsed, setCollapsed] = React.useState([])

  function toggleCollapse(section) {
    if (collapsed.includes(section)) {
      setCollapsed(collapsed.filter(s => s !== section))
    } else {
      setCollapsed([...collapsed, section])
    }
  }

  const { defaultLanguage, editableLanguages, publishedLanguages } = useSel(s => s.builder.flow)

  function setDefaultLanguage(lang) {
    act.builder.updateFlowLanguages(lang, editableLanguages, publishedLanguages)
  }
  function setEditableLanguages(langs) {
    const removedLangs = editableLanguages.filter(l => !langs.includes(l) && l !== defaultLanguage)
    const newPublishedLanguages = publishedLanguages.filter(l => !removedLangs.includes(l))
    act.builder.updateFlowLanguages(defaultLanguage, langs, newPublishedLanguages)
  }
  function setPublishedLanguages(langs) {
    act.builder.updateFlowLanguages(defaultLanguage, editableLanguages, langs)
  }

  const languageOptions = _.reduce(clientLanguages, (acc, lang, code) => {
    acc.push({ label: `${lang.name} ${lang.flag}`, value: code })
    return acc
  }, [] as Array<{ label: string, value: string }>)

  const usesTranslations = clientLanguages && Object.keys(clientLanguages).length > 1

  return <form>
    {usesTranslations &&
      <div>
        <SelectField label={"Default Language"} value={defaultLanguage} onChange={setDefaultLanguage} options={languageOptions} />
        <SelectField label={"Enable Editing Translations for"} value={editableLanguages.filter(Boolean).length > 0 ? editableLanguages : [defaultLanguage]} onChange={setEditableLanguages} options={languageOptions} isMulti />
        <SelectField label={"Publish Translations for"} value={publishedLanguages.filter(Boolean).length > 0 ? publishedLanguages : [defaultLanguage]} onChange={setPublishedLanguages} options={languageOptions} isMulti />
      </div>
    }
    <div>
      <div onClick={() => toggleCollapse('flow')} className="section-header">
        {collapsed.includes('flow') ? <SvgIconsUpCaret /> : <SvgIconsDownCaret />}<h2>{usesTranslations ? 'General Page Translations' : 'General Page Text'}</h2>
      </div>
      {collapsed.includes('flow') && <FlowTranslationSettings flow={flow} />}
    </div>
    <div>
      {orderedActions.map(action => (<>
        <div key={action.id}>
          <ActionTranslationSettings actionId={action.id} collapsed={collapsed.includes(`action-${action.id}`)}>
            <div className='section-header' onClick={() => toggleCollapse(`action-${action.id}`)}>
              {collapsed.includes(`action-${action.id}`) ? <SvgIconsUpCaret /> : <SvgIconsDownCaret />}
              <h2>Action: {(action.name || '(No name set)').replace(/_/gi, ' ')}</h2>
            </div>
          </ActionTranslationSettings>
        </div>
      </>))}
    </div>
    <ShareContentTranslationSection collapsed={collapsed} toggleCollapse={toggleCollapse} usesTranslations={usesTranslations} />
  </form>
}

function ShareContentTranslationSection({ collapsed, toggleCollapse, usesTranslations }) {
  const contentVariants = useSel(s =>
    (s.builder?.flow?.shareContentTest?.contentVariants || [])
      .filter(cv => cv.active !== false)
  )

  if (contentVariants.length === 0) return null

  return (
    <div>
      <div onClick={() => toggleCollapse('share-content')} className="section-header">
        {collapsed.includes('share-content') ? <SvgIconsUpCaret /> : <SvgIconsDownCaret />}
        <h2>{usesTranslations ? 'Share Content Translations' : 'Share Content Text'}</h2>
      </div>
      {collapsed.includes('share-content') && (
        <TranslateOptions>
          <ContentVariantTranslationSettings />
        </TranslateOptions>
      )}
    </div>
  )
}
